'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.accountEdit', {
        url: '/accountedit',
        templateUrl: 'app/accountEdit/accountEdit.html',
        controller: 'AccountEditCtrl',
				params: {
					new: false,
				}
      });
  });